const data = [
    { 
      id: 1,
      name: "Regra padrão do QGC",
    },
    { 
      id: 2,
      name: "Excluir do QGC",
    },
    { 
        id: 3,
        name: "Incluir no QGC",
      },
  ];
  
  export default [...data];
  